module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "weui-footer_fixed-bottom download"
  }, [_c('img', {
    staticClass: "download-icon",
    attrs: {
      "src": require("../assets/Shake_Phone_Filled_100.png")
    },
    on: {
      "click": _vm.click
    }
  })]), _vm._v(" "), _c('we-reactive-dialog', {
    attrs: {
      "is-show-dialog": _vm.isShowDownloadDialog
    },
    on: {
      "secondOnClick": _vm.cancelDownload,
      "mainOnClick": _vm.doDownload
    }
  }, [_c('div', {
    slot: "title"
  }, [_vm._v("下载APP")]), _vm._v(" "), _c('div', {
    slot: "content"
  }, [_vm._v("发现更多功能，请下载易退税APP")]), _vm._v(" "), _c('div', {
    slot: "main-operation"
  }, [_vm._v("去下载")]), _vm._v(" "), _c('div', {
    slot: "secondly-operation"
  }, [_vm._v("取消")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-59cb581a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DownloadApp.vue
// module id = 194
// module chunks = 2